import { useEffect } from "react"
import { useNavigate } from "react-router"

export default function ReadinessPage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate("/dashboard/gate2")
  }, [navigate])

  return null
}
